"use client"
import React, {useEffect, useState} from 'react'
import style from "components/Menu/menu.module.scss";
import LocalizedLinkClient from "components/LocalizedLink/LocalizedLinkClient";
import HamburgerOverlayMenu from "./components/HamburgerOverlayMenu";
import {useTekstClient} from "../../hooks/useTekstClient";
import mijnMkgLogo from '@/public/images/MKG-logo-2024_Menu_w172pxXh50px_full-color.png'
import Image from 'next/image'
export const MkgMenuClientSide = ({locale}) => {
    const {tekst, isLoadingTekst} = useTekstClient()
    const [isTop, setIsTop] = useState(true);

    const handleScroll = () => {
        setIsTop(window.scrollY === 0);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return <div  className={`absolute left-0 top-0 inset-0 flex items-center justify-center ${!isTop ? style.containScroll : ''}`}>
        <div className={`${style.container}`}>
            <LocalizedLinkClient href={`/`}>
                <Image src={mijnMkgLogo} alt={'MKG logo'} style={{padding: "4px 12px 4px 6px"}}/>
            </LocalizedLinkClient>

            <div className={`${style.menuLinks}`}>
                <LocalizedLinkClient href={`/#oplossingen`}>{tekst('website:menu:Oplossingen')}</LocalizedLinkClient>
                <LocalizedLinkClient href={`/mkg-add-ons`}>{tekst('website:menu:addons')}</LocalizedLinkClient>
                <LocalizedLinkClient href={`/over-mkg`}>{tekst('website:menu:overmkg')}</LocalizedLinkClient>
                <LocalizedLinkClient href={`/over-mkg#vacatures`}>{tekst('website:menu:vacatures')}</LocalizedLinkClient>
                <LocalizedLinkClient href={`/mijn-mkg/support`}>{tekst('website:menu:support')}</LocalizedLinkClient>
                <LocalizedLinkClient href={`/mijn-mkg/support`}>{tekst('website:menu:mijnmkg')}</LocalizedLinkClient>
            </div>
            <HamburgerOverlayMenu isTop={isTop} isMkgEu={true} locale={locale}/>
        </div>
    </div>


}